import { combineReducers } from "redux";

import { printerReducer } from "./printerReducer";

const rootReducer = combineReducers({ printerReducer });

export default rootReducer;
